import React from 'react';

const History_of_Robots = () => {
    return (
        <div>History_of_Robots Component</div>
    );
}

export default History_of_Robots;
